export default __webpack_public_path__ + "static/media/16558105781580594410.a8c64784.svg";